import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const MusicVersioningVersionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 236px;
  ${customizeVerticalScrollbarThumbMixin()};
  margin: 12px 0 20px 0;
  padding: 1px 16px;
  overflow-y: auto;
`
